/**
 * CliApiClient
 *
 * Handles CLI command execution via platform endpoints.
 * Uses POST /api/v1/cli/execute for single commands and
 * POST /api/v1/script/upload for batch script execution.
 *
 * @see VAIU-SHELL-CLI-MIGRATION-PLAN.md
 * @see VAIU-API-AGENT-PLATFORM-GUIDE.md
 */

import { BaseApiClient } from './BaseApiClient';

export interface CliExecuteResult {
  message: string;
  action?: string;
  data?: Record<string, unknown>;
  result?: Record<string, unknown>;
  executionTime?: number;
}

export interface ScriptUploadResult {
  sessionId: string;
  scriptFileName: string;
  totalCommands: number;
  successCount: number;
  failureCount: number;
  results: Array<{
    lineNumber: number;
    command: string;
    success: boolean;
    result?: Record<string, unknown>;
    error?: string;
  }>;
}

export class CliApiClient extends BaseApiClient {
  /**
   * Execute a single natural-language command via platform CLI
   */
  async execute(command: string): Promise<CliExecuteResult> {
    return this.post<CliExecuteResult>('/cli/execute', { command });
  }

  /**
   * Execute a batch of commands from script content
   */
  async uploadScript(scriptContent: string, fileName = 'script.vaiu'): Promise<ScriptUploadResult> {
    return this.post<ScriptUploadResult>('/script/upload', {
      scriptContent: scriptContent.trim(),
      fileName: fileName.trim() || 'script.vaiu',
    });
  }
}
